const NESTED_LIST_KEYS = [
  'list',
  'data',
  'records',
  'children',
  'item_list',
  'items',
  'fee_list',
  'order_list',
  'fee_data',
  'order_data',
  'detail_list',
  'details'
]

const ORDER_TYPE_MAP = {
  1: '电梯故障',
  2: '维修记录',
  3: '改造记录',
  4: '大修记录',
  5: '困人记录',
  6: '其他记录'
}

const LEVEL_MAP = {
  1: '低',
  2: '中',
  3: '高',
  4: '紧急'
}

const STATUS_MAP = {
  0: '待分配',
  1: '待处理',
  2: '已处理'
}

function pickArray(source) {
  if (Array.isArray(source)) return source
  if (source && typeof source === 'object') return [source]
  return []
}

function pickNestedList(item) {
  if (!item || typeof item !== 'object') return []

  for (let i = 0; i < NESTED_LIST_KEYS.length; i += 1) {
    const nested = item[NESTED_LIST_KEYS[i]]
    if (Array.isArray(nested) && nested.length) {
      return nested
    }
  }
  return []
}

function pickFlatList(data, keys) {
  if (!data || typeof data !== 'object') return []
  for (let i = 0; i < keys.length; i += 1) {
    const list = pickArray(data[keys[i]])
    if (list.length) return list
  }
  return []
}

function getGroupName(item, index) {
  return (
    item.name ||
    item.month ||
    item.month_name ||
    item.type_name ||
    item.group_name ||
    item.label ||
    `类型${index + 1}`
  )
}

function normalizeMonthToken(name) {
  const text = String(name || '').trim()
  if (!text) return ''
  const monthMatch = text.match(/(\d{1,2})\s*月/)
  if (monthMatch) {
    return String(Number(monthMatch[1])).padStart(2, '0')
  }
  const dateMatch = text.match(/(\d{4})[-/年](\d{1,2})/)
  if (dateMatch) {
    return `${dateMatch[1]}-${String(Number(dateMatch[2])).padStart(2, '0')}`
  }
  return text
}

function recordTimeText(record) {
  return (
    record.createtime ||
    record.create_time ||
    record.createTime ||
    record.pay_time ||
    record.payTime ||
    record.time ||
    record.date ||
    ''
  )
}

function getOrderTypeLabel(record) {
  return (
    record.order_type_text ||
    record.orderType ||
    record.order_type_name ||
    ORDER_TYPE_MAP[record.order_type] ||
    (record.order_type != null ? String(record.order_type) : '')
  )
}

export function getOrderLevelLabel(record) {
  if (record.level_text) return record.level_text
  const level = record.level
  if (level != null && level !== '' && LEVEL_MAP[level] != null) {
    return LEVEL_MAP[level]
  }
  return level != null && level !== '' ? String(level) : '-'
}

export function getOrderStatusLabel(record) {
  if (record.status_text) return record.status_text
  const status = record.status
  if (status != null && status !== '' && STATUS_MAP[status] != null) {
    return STATUS_MAP[status]
  }
  return status != null && status !== '' ? String(status) : '-'
}

export function formatDateTime(value) {
  if (value == null || value === '') return '-'

  const text = String(value).trim()
  if (/^\d{10,13}$/.test(text)) {
    const ts = Number(text)
    const date = new Date(text.length === 10 ? ts * 1000 : ts)
    if (!Number.isNaN(date.getTime())) {
      return formatDateObject(date)
    }
  }

  const parsed = new Date(text.replace(/-/g, '/'))
  if (!Number.isNaN(parsed.getTime())) {
    return formatDateObject(parsed)
  }

  const matched = text.match(/^(\d{4}[-/]\d{2}[-/]\d{2})\s+(\d{2}:\d{2})/)
  if (matched) {
    return `${matched[1].replace(/\//g, '-')} ${matched[2]}`
  }

  return text.length > 16 ? text.slice(0, 16) : text
}

function formatDateObject(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${year}-${month}-${day} ${hours}:${minutes}`
}

/** 缴费金额：保留 2 位小数，向下取整 */
export function formatFeeAmount(value) {
  if (value === '' || value == null) return ''
  const num = Number(String(value).replace(/,/g, '').trim())
  if (!Number.isFinite(num)) return String(value)
  return (Math.floor(num * 100) / 100).toFixed(2)
}

function pickRawFeeAmount(item) {
  if (!item || typeof item !== 'object') return ''
  return (
    item.amount ??
    item.fee ??
    item.money ??
    item.price ??
    item.pay_money ??
    item.pay_amount ??
    item.payMoney ??
    item.total_amount ??
    item.totalAmount ??
    item.fee_amount ??
    item.feeAmount ??
    item.payment_amount ??
    item.paymentAmount ??
    item.real_pay ??
    item.realPay ??
    item.pay_fee ??
    item.payFee ??
    ''
  )
}

function pickFeeCreateDay(item) {
  if (item.create_day != null && item.create_day !== '') {
    return String(item.create_day)
  }
  return ''
}

const FEE_PAY_STATUS_MAP = {
  1: '未缴',
  2: '已缴'
}

function pickFeePayContent(item) {
  return (
    item.loudong ??
    item.pay_content ??
    item.fee_content ??
    item.payment_content ??
    item.content_title ??
    item.title ??
    item.subject ??
    item.remark ??
    item.note ??
    ''
  )
}

function pickFeePayStatus(item) {
  if (item.pay_status_text) return item.pay_status_text
  const status = item.status ?? item.pay_status
  if (status != null && status !== '') {
    const code = Number(status)
    if (Number.isFinite(code) && FEE_PAY_STATUS_MAP[code] != null) {
      return FEE_PAY_STATUS_MAP[code]
    }
  }
  if (item.status_text) return item.status_text
  return status != null && status !== '' ? String(status) : ''
}

function pickFeeOwnerName(item) {
  return (
    item.user_name ??
    item.owner_name ??
    item.owner ??
    item.yezhu_name ??
    item.yezhu ??
    item.proprietor_name ??
    item.username ??
    ''
  )
}

function pickFeeCommunityName(item) {
  return (
    item.community_name ||
    item.area_name ||
    item.project_name ||
    item.name ||
    ''
  )
}

function pickFeeCreateTime(item) {
  const raw =
    item.createtime ??
    item.create_time ??
    item.createTime
  return raw ? formatDateTime(raw) : '-'
}

export function normalizeFeeRecords(list) {
  return pickArray(list).map((item) => ({
    community_name: pickFeeCommunityName(item),
    owner_name: pickFeeOwnerName(item),
    pay_year: pickFeeCreateDay(item),
    create_day: pickFeeCreateDay(item),
    pay_content: pickFeePayContent(item),
    amount: formatFeeAmount(pickRawFeeAmount(item)),
    pay_status: pickFeePayStatus(item),
    createTime: pickFeeCreateTime(item)
  }))
}

export function normalizeOrderRecords(list) {
  return pickArray(list).map((item) => ({
    createTime: formatDateTime(recordTimeText(item)),
    communityAddress:
      item.community_name ||
      item.area_name ||
      item.area_id ||
      item.project_name ||
      item.name ||
      '',
    orderType: getOrderTypeLabel(item),
    order_type: item.order_type,
    level: getOrderLevelLabel(item),
    status: getOrderStatusLabel(item),
    orderEvent: item.content || '',
    repairContent: item.repair_content || '',
    orderImage: item.images || '',
    repairImage: item.repair_images || ''
  }))
}

function matchFeeRecords(flatRecords, groupItem) {
  const category = getGroupName(groupItem)
  const monthToken = normalizeMonthToken(category)

  return flatRecords.filter((record) => {
    const payDay = String(record.create_day || record.pay_year || '')
    const time = record.createTime || recordTimeText(record) || ''

    if (payDay && category && (category.includes(payDay) || payDay.includes(category))) {
      return true
    }
    if (category && time.includes(category)) return true
    if (monthToken && time.includes(monthToken)) return true
    if (monthToken.length === 2 && time.includes(`-${monthToken}`)) return true
    if (monthToken.length === 7 && time.startsWith(monthToken)) return true
    return false
  })
}

function matchOrderRecords(flatRecords, groupItem) {
  const category = getGroupName(groupItem).trim()
  const typeCode = groupItem.type ?? groupItem.order_type ?? groupItem.event

  return flatRecords.filter((record) => {
    if (typeCode != null && typeCode !== '' && String(record.order_type) === String(typeCode)) {
      return true
    }
    const typeLabel = getOrderTypeLabel(record).trim()
    if (category && typeLabel && typeLabel === category) return true
    if (category && typeLabel && (typeLabel.includes(category) || category.includes(typeLabel))) {
      return true
    }
    return false
  })
}

function parseGroupDetails(item, flatRecords, normalizeRecord, matchFn) {
  if (Array.isArray(flatRecords) && flatRecords.length) {
    const fromFlat = matchFn(flatRecords, item)
    if (fromFlat.length) return fromFlat
  }

  const nested = pickNestedList(item)
  if (nested.length) {
    return normalizeRecord(nested)
  }

  return matchFn(flatRecords, item)
}

function buildChartDataFromGroup(groupArray, flatRecords, normalizeRecord, matchFn, keyPrefix) {
  if (!Array.isArray(groupArray)) return []

  return groupArray
    .map((item, index) => {
      if (!item || typeof item !== 'object') return null

      const name = getGroupName(item, index)
      const details = parseGroupDetails(item, flatRecords, normalizeRecord, matchFn)
      const countFromApi = Number(item.num ?? item.count ?? item.value)
      const value = Number.isFinite(countFromApi) && countFromApi > 0
        ? countFromApi
        : details.length

      return {
        key: `${keyPrefix}-${name}-${index}`,
        name,
        value,
        details
      }
    })
    .filter(Boolean)
}

export function buildHomeFeeChartData(feeData, flatRecords = []) {
  const normalizedFlat = normalizeFeeRecords(
    Array.isArray(flatRecords) && flatRecords.length ? flatRecords : []
  )
  return buildChartDataFromGroup(
    feeData,
    normalizedFlat,
    normalizeFeeRecords,
    matchFeeRecords,
    'fee'
  )
}

export function buildHomeOrderChartData(orderData, flatRecords = []) {
  const normalizedFlat = Array.isArray(flatRecords) && flatRecords.length
    ? flatRecords
    : normalizeOrderRecords(flatRecords)
  return buildChartDataFromGroup(
    orderData,
    normalizedFlat,
    normalizeOrderRecords,
    matchOrderRecords,
    'order'
  )
}

export function extractHomeFeeRecords(data) {
  return normalizeFeeRecords(
    pickFlatList(data, [
      'fee_list',
      'fee_record',
      'fee_records',
      'pay_list',
      'pay_data',
      'fee_detail',
      'fee_detail_list'
    ])
  )
}

export function extractHomeOrderRecords(data) {
  return normalizeOrderRecords(
    pickFlatList(data, [
      'order_list',
      'order_record',
      'order_records',
      'inspection_order',
      'order_detail',
      'order_detail_list'
    ])
  )
}

export function filterChartDetailsByItem(details, chartItem, flatRecords, matchFn) {
  if (Array.isArray(flatRecords) && flatRecords.length) {
    const fromFlat = matchFn(flatRecords, chartItem)
    if (fromFlat.length) return fromFlat
  }
  if (Array.isArray(details) && details.length) {
    return details
  }
  if (!chartItem || !Array.isArray(flatRecords)) return []
  return matchFn(flatRecords, chartItem)
}

export function filterFeeDetailsByItem(details, chartItem, flatRecords) {
  const matched = filterChartDetailsByItem(details, chartItem, flatRecords, matchFeeRecords)
  return normalizeFeeRecords(matched)
}

export function filterOrderDetailsByItem(details, chartItem, flatRecords) {
  return filterChartDetailsByItem(details, chartItem, flatRecords, matchOrderRecords)
}
